module.exports = __webpack_public_path__ + "static/media/powerlink.f8759f83.png";